module.exports = __webpack_public_path__ + "static/assets/19c3f62a80f45ea42068a8d31ca27316.gif";